<template>
  <div>
    <div class="product-panel-title">
      成功案例
    </div>
    <div class="product-panel-desp">
      因为有你们，才有现在的我们，永远保持一颗感恩的心
    </div>
    <div class="domain-panel-line"/>
    <div class="domain-panel-content">
      <ProductItem v-for="(product,index) in products" :itemData="product" :key="index"/>
    </div>
  </div>
</template>

<script>
  import ProductItem from './ProductItem'

  export default {
    name: 'ProductPanel',
    components: {ProductItem},

    data () {
      return {
        products: [
          {
            bgUrl: require('../assets/images/case1.png'),
            title: '北方鹅',
            content: '北方鹅微信小程序商城(NORTHERN GOOSE)'
          },
          {
            bgUrl: require('../assets/images/case2.png'),
            title: '日美开开',
            content: '智能终端管理系统，用手机随时随地管理您的产品'
          },
          {
            bgUrl: require('../assets/images/case3.png'),
            title: '心易科技',
            content: '杭州心易科技有限公司官网，时尚酷炫的页面设计'
          },
          {
            bgUrl: require('../assets/images/case4.png'),
            title: '新中大',
            content: '钉钉第三方集成，让您的应用无缝衔接第三方应用'
          },
          {
            bgUrl: require('../assets/images/case5.png'),
            title: '盲盒',
            content: '盲盒系统，日复一日、年复一年的生活需要来点惊喜'
          },
          {
            bgUrl: require('../assets/images/case6.png'),
            title: '基沐科技',
            content: '社交类产品，分享您的点点滴滴，让更多的人走进你的生活'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .product-panel-title {
    text-align: center;
    margin-top: 8.542vw;
    font-size: 3.125vw;
    margin-bottom: 0.8854vw;
    color: #1158E8;
    font-family: PingFangSC-Semibold;
  }

  .product-panel-desp {
    font-family: PingFangSC-Regular;
    font-size: 1.042vw;
    color: #999999;
    text-align: center;
    line-height: 1.5625vw;
  }

  .domain-panel-line {
    width: 5.677vw;
    height: 0.3125vw;
    background-color: #1158E8;
    margin: 1.875vw auto 5.208vw auto;
  }

  .domain-panel-content {
    margin-left: 11.927vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductPanel.vue